export default class Dropdown {
  constructor() {
    const dropdowns = document.querySelectorAll('.dropdown');

    if (dropdowns) {
      dropdowns.forEach((dropdown) => {
        const trigger = dropdown.querySelector('.dropdown-trigger');

        if (trigger) {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            dropdown.classList.toggle('is-active');
          });
        }
      });
    }
  }
}
